<template>
    <div>
        <h1>Niet gevonden</h1>

        <p>Je hebt een pagina opgevraagd die niet bestaat. Misschien een verkeerde URL ingetypt?</p>
    </div>
</template>

<script>
export default {
  metaInfo: {
    title: '404'
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Error404.vue